import React from 'react';
import styles from './DashboardContentMaxWidth.module.scss';

interface Props {
  children: React.ReactNode;
  disabled?: boolean;
}
function DashboardContentMaxWidth({ children, disabled }: Props) {
  if (disabled) return children;
  return <div className={styles.root}>{children}</div>;
}

export default DashboardContentMaxWidth;
